module.exports = __webpack_public_path__ + "img/one2.d859f54b.png";